import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { generateBOLPDF } from './BOLPdfGenerator';

const BOLPrint = () => {
    const { bolID } = useParams();
    const [bolData, setBolData] = useState(null);

    useEffect(() => {
        if (bolID) {
            axios.get(`/api/bol/${bolID}`)
                .then(response => {
                    const data = response.data;

                    // Format and structure data for printing
                    setBolData({
                        ...data,
                        items: data.items.map(item => ({
                            ...item,
                            quantity: item.bolQuantity || 0,
                            weight: Number(item.bolWeightSub || 0).toFixed(2),
                            volume: Number(item.bolItemGalSum || 0).toFixed(2),
                        })),
                    });
                })
                .catch(error => console.error('Error fetching Bill of Lading:', error));
        }
    }, [bolID]);

    if (!bolData) {
        return <p>Loading...</p>;
    }

    const { shipperName, shipperAddress, shipperCity, shipperState, shipperZip, shipperPhone,
        carrierName, carrierAddress, carrierCity, carrierState, carrierZip, carrierPhone,
        consigneeName, consigneeAddress, consigneeCity, consigneeState, consigneeZip, consigneePhone,
        bolShipdate, bolTAX, bolTotalItems, bolTotalWeight, items, bolInstructions } = bolData;
    const getAlcoholText = (proAlc) => {
        if (proAlc > 16) {
            return "Over 16% Alc.";
        } else if (proAlc > 14) {
            return "Over 14% Alc.";
        } else {
            return "Under 14% Alc.";
        }
    };
    return (
        <div className="print-container">
        <div className="d-flex align-items-center mb-4">
            <div>
                <img src="https://jeremywineco.com/wp-content/themes/BOX/img/j-logo.png" alt="Company Logo" style={{ height: '100px', marginRight: '20px' }} />
            </div>
            <div>
                <h2 className="mb-1">Straight Bill of Lading</h2>
                <h6 className="mb-0">Short Form - Original - Not Negotiable</h6>
                <h6 className="mt-2"><strong>Date:</strong> {new Date(bolShipdate).toLocaleDateString()} | <strong>Tax Status:</strong> {bolTAX}</h6>
            </div>
            
            <div className="ms-auto text-end" style={{ borderLeft: '2px solid lightgrey', paddingLeft: '15px' }}>
                <h3 className="mb-0">No: {new Date().getFullYear()}-{bolID}</h3>
                <h6>{new Date(bolShipdate).toLocaleDateString()}</h6>
            </div>
        </div>
            <div className="row mb-4">
                <div className="col-md-4">
                    <div className="card">
                        <div className="card-header"><strong>Shipper</strong>
                        <button 
                            className="btn btn-primary mb-3"
                            onClick={() => bolData && generateBOLPDF(bolData)}
                        >
                            Download PDF
                        </button>
                        </div>
                        <div className="card-body">
                            <p><strong>{shipperName}</strong><br />
                                {shipperAddress}<br />
                                {shipperCity}, {shipperState} {shipperZip}<br />
                                {shipperPhone}
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="card">
                        <div className="card-header"><strong>Carrier</strong></div>
                        <div className="card-body">
                            <p><strong>{carrierName}</strong><br />
                                {carrierAddress}<br />
                                {carrierCity}, {carrierState} {carrierZip}<br />
                                {carrierPhone}
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="card">
                        <div className="card-header"><strong>Consignee</strong></div>
                        <div className="card-body">
                            <p><strong>{consigneeName}</strong><br />
                                {consigneeAddress}<br />
                                {consigneeCity}, {consigneeState} {consigneeZip}<br />
                                {consigneePhone}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <table className="table" style={{ borderCollapse: 'collapse', width: '100%' }}>
                <thead>
                    <tr style={{ borderBottom: '2px solid black' }}>
                        <th style={{ textAlign: 'left', padding: '8px' }}>Qnty.</th>
                        <th style={{ textAlign: 'left', padding: '8px' }}>Description (Contains Sulfites)</th>
                        <th style={{ textAlign: 'left', padding: '8px' }}>Weight</th>
                    </tr>
                </thead>
                <tbody>
                    {bolData.items?.map((item, index) => (
                        <tr key={index} style={{ borderBottom: '1px dashed grey' }}>
                            <td style={{ padding: '8px' }}>{item.quantity}</td>
                            <td style={{ padding: '8px' }}>
                                <div style={{ borderRight: '1px solid lightgrey', height: '100%', margin: 'auto 0' }}>
                                    {item.proVintage} {item.proVarietal} {item.proFanciful} | {item.proPack}x{item.proLiters ? (item.proLiters * 1000).toFixed(0) : '0'} ML - {getAlcoholText(item.proAlc)} | {item.bolItemGalSum} Gal.<br />
                                    {item.proWineType || ''} | {item.proAppellation || ''}
                                </div>
                            </td>
                            <td style={{ padding: '8px' }}>{item.bolWeightSub}Lbs</td>
                        </tr>
                    ))}
                    <tr style={{ borderTop: '2px solid black' }}>
                        <td style={{ padding: '8px', fontWeight: 'bold', textAlign: 'Left' }}>Total Bill of Lading Items: {bolData.bolTotalItems}</td>
                        <td style={{ padding: '8px', textAlign: 'right' }}>Total Bill of Lading Weight:</td>
                        <td style={{ padding: '8px', textAlign: 'left' }}>{bolData.bolTotalWeight} lbs</td>
                        <td style={{ padding: '8px' }}></td>
                    </tr>
                </tbody>
            </table>

            <h6>Instructions</h6>
            <p>{bolInstructions || 'None'}</p>
            <hr/>
            <p className="small">
                RECEIVED, subject to applicable classifications and tariffs, the property described above in apparent good order except as noted. This shipment is subject to the terms and conditions of the Uniform Domestic Straight Bill of Lading, as applicable. The shipper certifies the accuracy of the information provided and agrees to the conditions herein. Delivery is subject to payment of freight and other lawful charges.
            </p>
            <hr/>
            <div className="container mt-5">
    <div className="row text-center">
        <div className="col-4" style={{ borderRight: '1px solid #ccc', paddingRight: '15px', marginBottom: "0px" }}>
                    <p style={{ marginBottom: "0px" }}>X <span style={{ borderBottom: '1px solid black', display: 'inline-block', width: '90%' }}></span></p>
                    <h6>SHIPPER</h6>
                </div>
                <div className="col-4" style={{ borderRight: '1px solid #ccc', paddingRight: '15px', marginBottom: "0px" }}>
                    <p style={{ marginBottom: "0px" }}>X <span style={{ borderBottom: '1px solid black', display: 'inline-block', width: '90%' }}></span></p>
                    <h6>CARRIER</h6>
                </div>
                <div className="col-4">
                    <p style={{ marginBottom: "0px" }}>X <span style={{ borderBottom: '1px solid black', display: 'inline-block', width: '90%', marginBottom: "0px" }}></span></p>
                    <h6>CONSIGNEE</h6>
                </div>
            </div>
        </div>
        </div>
    );
};

export default BOLPrint;